"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .factory("ExportConfigSrv", function ($rootScope, $resource) {
    const Config = $resource($rootScope.globalConfig.apipath + "/company/:id/export-config", {
      id: this.id,
    })

    const Log = $resource(
      $rootScope.globalConfig.apipath + "/company/:id/export-log",
      {
        id: this.id,
      },
      { get: { method: "GET", isArray: true } }
    )

    return {
      Config,
      Log,
    }
  })
